import Vue from 'vue'
import Vuex from 'vuex'

import Account from './modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Account
  }
})
